module.exports = __webpack_public_path__ + "static/media/short-arrow-t-green.4c3c8e50.svg";